<h1>Post Lab Test <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
<div class="row" *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
<div class="row">
    <div class="col-sm-8 border-right">
    <form [formGroup]="LabLeadForm" (submit)="updateLead()">
        <div class="col-md-12 mb-sm-4 mt-sm-4" #screen>
        <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <label class="form-label">Patient Name *</label>
                    <input type="text" formControlName="patient_name" class="form-control" />
                    <div *ngIf="submitted && f.patient_name.errors" class="invalid-feedback">
                        <div *ngIf="f.patient_name.errors.required">Patient Name is required</div>
                    </div>
                    <div *ngIf="(f.patient_name.value=='NA' || f.patient_name.value=='N/A') && invalidName" class="invalid-feedback">
                        <div>Please enter valid name</div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <label class="form-label">Patient Mobile *</label>
                    <input type="text" formControlName="mobile" class="form-control" readonly />
                    <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                        <div *ngIf="f.mobile.errors.required">Patient Mobile is required</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <label class="form-label">Patient Age</label>
                    <input type="number" formControlName="patient_age" class="form-control" />
                </div>
                <div class="col-sm-6">
                    <label class="form-label">Gender</label>
                    <mat-select placeholder="Select Gender" formControlName="gender">
                        <mat-option value="Male">Male</mat-option>
                        <mat-option value="Female">Female</mat-option>
                    </mat-select>
                </div>
            </div>
        </div>

       
        <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <label class="form-label">Test Category</label>
                    <mat-select placeholder="Select Category"  formControlName="lab_test_category" (click)="setSearchValue('testCategory')"
                    (selectionChange)="getLabTestCategorySubcategory($event.value)">
                        <input class="mySearchInput"
                        #testCategorySearch focused="'true'" type="text"
                        (keyup)="searchOnSelect($event.target.value, 'testCategory')"
                        (keydown)="$event.stopPropagation()" autocomplete="off"
                        placeholder="Search"
                        id="testCategorySearch">
                        <mat-option value="">Select Category</mat-option>
                        <mat-option [value]="test.id" *ngFor="let test of testCategory">{{test.name}}</mat-option>
                    </mat-select>
                </div>
                 <div class="col-sm-6">
                    <label class="form-label">Test Subcategory</label>
                    <mat-select placeholder="Select Subcategory" formControlName="lab_test_subcategory" (click)="setSearchValue('testSubcategory')">
                        <input class="mySearchInput"
                        #testSubcategorySearch focused="'true'" type="text"
                        (keyup)="searchOnSelect($event.target.value, 'testSubcategory')"
                        (keydown)="$event.stopPropagation()" autocomplete="off"
                        placeholder="Search"
                        id="testSubcategorySearch">
                        <mat-option value="">Select Subcategory</mat-option>
                        <mat-option [value]="test.id" *ngFor="let test of labTestSubcategory">{{test.name}}</mat-option>
                    </mat-select>
                 </div>
               
            </div>
        </div>

        <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <label class="form-label">City</label>
                    <mat-select placeholder="Select City" formControlName="city_id" (click)="setSearchValue('city')">
                        <input class="mySearchInput"
                        #citySearch focused="'true'" type="text"
                        (keyup)="searchOnSelect($event.target.value, 'city')"
                        (keydown)="$event.stopPropagation()" autocomplete="off"
                        placeholder="Search"
                        id="citySearch">
                        <mat-option [value]="city.city_id" *ngFor="let city of cities">{{city.name}}</mat-option>
                    </mat-select>
                </div>

                <div class="col-sm-6">
                    <label class="form-label">Circle</label>
                    <mat-select placeholder="Select Circle" formControlName="circle_id" (click)="setSearchValue('circle')">
                        <input class="mySearchInput"
                        #circleSearch focused="'true'" type="text"
                        (keyup)="searchOnSelect($event.target.value, 'circle')"
                        (keydown)="$event.stopPropagation()" autocomplete="off"
                        placeholder="Search"
                        id="circleSearch">
                        <mat-option value="">Select Circle</mat-option>
                        <mat-option [value]="circle.id" *ngFor="let circle of circles">{{circle.name}}</mat-option>
                    </mat-select>
        
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <label class="form-label">Status</label>
                    <mat-select placeholder="Select Status" formControlName="status" (click)="setSearchValue('status')">
                        <input class="mySearchInput"
                        #statusSearch focused="'true'" type="text"
                        (keyup)="searchOnSelect($event.target.value, 'status')"
                        (keydown)="$event.stopPropagation()" autocomplete="off"
                        placeholder="Search"
                        id="statusSearch">
                        <mat-option value="">Select Status</mat-option>
                        <mat-option [value]="status.id" *ngFor="let status of leadallStatus">{{status.name}}</mat-option>
                    </mat-select>
                </div>
                <div class="col-sm-6">
                    <label class="form-label">Treatment</label>
                    <mat-select placeholder="Select Treatment" formControlName="treatment_id" (click)="setSearchValue('treatment')">
                        <input class="mySearchInput"
                        #treatmentSearch focused="'true'" type="text"
                        (keyup)="searchOnSelect($event.target.value, 'treatment')"
                        (keydown)="$event.stopPropagation()" autocomplete="off"
                        placeholder="Search"
                        id="treatmentSearch">
                        <mat-option  [value]="treatment.id" *ngFor="let treatment of treatments">{{treatment.name}}</mat-option>
                    </mat-select>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label class="form-label">Payment Mode</label>
                        <mat-select  formControlName="payment_mode" placeholder="Select Payment Mode">
                            <mat-option>Select</mat-option>
                            <mat-option value="Cash">Cash</mat-option>
                            <mat-option value="Cashless">Cashless</mat-option>
                            <mat-option value="Reimbursement">Reimbursement</mat-option>
                            <mat-option value="EMI">EMI</mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>
        </div>
        <hr />
        <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <label class="form-label">Scan In</label>
                    <mat-select placeholder="Scan In" formControlName="test_in">
                        <mat-option value="">Select Scan In</mat-option>
                        <mat-option [value]="1">In Lab</mat-option>
                        <mat-option [value]="2">In Hospital</mat-option>
                    </mat-select>
                </div>

                <div class="col-sm-6" *ngIf="LabLeadForm.controls['test_in'].value==2">
                    <label class="form-label">Hospital</label>
                    <mat-select placeholder="Select Hospital" formControlName="hospital_id" (click)="setSearchValue('hospital')" >
                        <input class="mySearchInput"
                        #hospitalSearch focused="'true'" type="text"
                        (keyup)="searchOnSelect($event.target.value, 'hospital')"
                        (keydown)="$event.stopPropagation()" autocomplete="off"
                        placeholder="Search"
                        id="hospitalSearch">
                        <mat-option value="">Select Hospital</mat-option>
                        <mat-option [value]="hospital.id" *ngFor="let hospital of hospitals">{{hospital.name}}</mat-option>
                    </mat-select>
                </div>
                <div class="col-sm-6" *ngIf="LabLeadForm.controls['test_in'].value==1">
                    <label class="form-label">Lab</label>
                    <mat-select placeholder="Select Lab" formControlName="lab_id" (click)="setSearchValue('labs')">
                        <input class="mySearchInput"
                        #hospitalSearch focused="'true'" type="text"
                        (keyup)="searchOnSelect($event.target.value, 'labs')"
                        (keydown)="$event.stopPropagation()" autocomplete="off"
                        placeholder="Search"
                        id="labsSearch">
                        <mat-option value="">Select Lab</mat-option>
                        <mat-option [value]="lab.id" *ngFor="let lab of labs">{{lab.name}}</mat-option>
                    </mat-select>
                </div>
            </div>
        </div>
        <hr />
        <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <label class="form-label">Collection Type</label>
                    <mat-select placeholder="Select Collection Type" formControlName="collection_type">
                        <mat-option [value]="0">Home Collection</mat-option>
                        <mat-option [value]="1">Center Collection</mat-option>
                    </mat-select>
                </div>

                <div class="col-sm-6">
                    <label class="form-label">Select BD</label>
                    <mat-select placeholder="Select BD"  formControlName="user_id" (click)="setSearchValue('lead_owner')">
                        <input class="mySearchInput"
                        #ownerSearch focused="'true'" type="text"
                        (keyup)="searchOnSelect($event.target.value, 'lead_owner')"
                        (keydown)="$event.stopPropagation()" autocomplete="off"
                        placeholder="Search"
                        id="ownerSearch">
                        <mat-option value="">Select BD</mat-option>
                        <mat-option [value]="bd.id" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                    </mat-select>
                  
                </div> 
               
              
            </div>
        </div>

        <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <label class="form-label">Address </label>
                    <textarea  formControlName="address" [readonly]="myrole=='5'" class="form-control" ></textarea>
                </div>
                <div class="col-sm-6">
                    <label class="form-label">Description</label>
                    <textarea  formControlName="description" [readonly]="myrole=='5'" class="form-control" ></textarea>
                </div>
            </div>
           
        </div>
      
        <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <label class="form-label">Sample Collection Date/Test</label>
                    <input type="datetime-local" formControlName="sample_collection_date" class="form-control"/>
                </div>
                
                <div class="col-sm-6">
                    <label class="form-label">Report Generated Date</label>
                    
                    <mat-form-field appearance="fill">
                        <mat-label>Choose a date</mat-label>
                        <input matInput readonly formControlName="report_generated_date" [matDatepicker]="picker1">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    
                    
                </div>
            </div>
        </div>
       <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <label class="form-label">Booking Amount</label>

                </div>
                <div class="col-sm-6">
                    <input formControlName="booking_amt" class="form-control" (keyup)="getBalance()" />
                </div>
            </div>
        </div>

        <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <label class="form-label">Due Amount</label>
                </div>
                <div class="col-sm-6">
                    <input type="text" formControlName="due_amt" class="form-control" (keyup)="getBalance()" />
                </div>
            </div>
        </div>


        <div class="form-group">
            <div class="row">
                <div class="col-sm-6 mb-sm-4">
                    <label class="form-label">Balance</label>
                </div>
                <div class="col-sm-6 mb-sm-4">
                    <input type="text" formControlName="balance" class="form-control" readonly/>
                </div>
            </div>
        </div>

        <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <label class="form-label">Revenue Amount</label>
                </div>
                <div class="col-sm-6">
                    <input type="text" formControlName="revenue" class="form-control" />
                </div>
            </div>
        </div>

        </div>
      
        <div class="card-footer">
            <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Update</button>
        </div>
        </form>
    </div>

    <div class="col-sm-4">
        <h2>Upload Lab Test Documents</h2>
        <div class="form-group">
            <label>Select Document Type</label>
            <mat-select [(ngModel)]="doc_type" placeholder="Select Document Type">
                <mat-option value="">Select Document Type</mat-option>
                <mat-option [value]="1">Test Report</mat-option>
                <mat-option [value]="2">Aadhar</mat-option>
                <mat-option [value]="3">Prescription</mat-option>
            </mat-select>
        </div>
        <div class="form-group">
            <label>Upload Documents</label>
            <input [disabled]="uploading" type="file" (change)="selectFile($event)" class="form-control" />
            <span *ngIf="uploading"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
        </div>


        <div class="list-group list-group-flush list-group-hoverable">
            <p *ngIf="fileDeleting"><i class="fa fa-spin fa-spinner"></i> deleting file...</p>
            <div class="list-group-item" *ngFor="let upload of allUploads">
                <div class="row align-items-center">
                    <div class="col text-truncate">
                        <a href="{{s3url}}{{upload.filepath}}" target="_blank" class="text-body d-block">View File</a>
                        <a *ngIf="myrole=='1' || myrole=='17'" class="delete-file" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                        [cancelText]="cancelText" [placement]="placement" (confirm)="removeFile(upload.id)" (cancel)="cancelClicked = true"
                        confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                        [appendToBody]="true"><i class="fa fa-trash"></i></a>

                        <span class="badge badge-success" *ngIf='upload.upload_type==1'>Test Report</span>
                        <span class="badge badge-primary" *ngIf='upload.upload_type==2'>Aadhar</span>
                        <span class="badge badge-secondary" *ngIf='upload.upload_type==3'>Prescription</span>
                      
                        <small class="d-block text-muted text-truncate mt-n1">{{upload.filepath}}</small>
                    </div>
                </div>
            </div>
           
        </div>

        
    </div>
    
</div>
